import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
const faqs = [{
  q: '¿El producto es digital?',
  a: 'Sí, es 100% digital. Recibís todo en formato PDF descargable.'
}, {
  q: '¿Recibo todos los bonus?',
  a: 'Sí. Al confirmar tu compra accedés inmediatamente al ebook principal + los 6 bonus.'
}, {
  q: '¿Puedo verlo desde el celular?',
  a: 'Sí, podés acceder desde cualquier dispositivo: celular, tablet, notebook o PC.'
}, {
  q: '¿Es útil para tatuadores?',
  a: 'Totalmente. Es una referencia visual e histórica ideal para tatuadores, diseñadores y artistas.'
}, {
  q: '¿Sirve si todavía no tengo tatuajes?',
  a: 'Por supuesto. Es perfecto para quienes están investigando antes de decidir su primer irezumi.'
}, {
  q: '¿Tengo acceso de por vida?',
  a: 'Sí. Una sola compra y lo tenés para siempre, con todas las futuras actualizaciones.'
}, {
  q: '¿Incluye garantía?',
  a: 'Sí. Tenés 7 días para revisar todo el material. Si no te convence, te devolvemos el 100%.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-57">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-58">
            <span className="text-xs font-bold tracking-widest" data-id="element-59">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-60">
            Preguntas{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-61">
              frecuentes
            </span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-62">
          {faqs.map((f, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-bg-warm border border-line rounded-2xl overflow-hidden shadow-sm" data-id="element-63">
              <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between p-5 md:p-6 text-left" data-id="element-64">
                <span className="font-semibold text-ink text-base md:text-lg pr-4" data-id="element-65">
                  {f.q}
                </span>
                <motion.div animate={{
              rotate: open === i ? 45 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-66">
                  <PlusIcon className="w-5 h-5 text-rose flex-shrink-0" data-id="element-67" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-68">
                {open === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} className="overflow-hidden" data-id="element-69">
                    <div className="px-5 md:px-6 pb-5 text-ink-soft" data-id="element-70">{f.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}